import React from 'react';
import InterviewsTemplate from '~src/components/templates/Interviews';

const Interviews = () => (<InterviewsTemplate />);

export default Interviews;
